import { render, staticRenderFns } from "./marcas.vue?vue&type=template&id=23b04ac2&scoped=true&"
import script from "./marcas.vue?vue&type=script&lang=js&"
export * from "./marcas.vue?vue&type=script&lang=js&"
import style0 from "./marcas.vue?vue&type=style&index=0&id=23b04ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b04ac2",
  null
  
)

export default component.exports